import React from "react";
import ButtonUtility from "../../Components/Buttons/Utility";
import { AttachmentCardProps } from "../../Models/Attachment";
import { useAppContext } from "../../AppProvider"; // Importiamo il context qui
import ZPLViewer from "../../Components/common/ZPLViewer";

export const AttachmentCard: React.FC<AttachmentCardProps> = ({
  item,
  shipment,
  ddtEnabled,
  setDdtEnabled,
}) => {
  const { dictionary } = useAppContext();
  const isZPL = item?.type?.format === "ZPL";

  return (
    <>
      <label className="label-3 mb-2">{item?.type?.name}</label>
      {isZPL ? (
        <>
          <ZPLViewer
            // reference={
            //   shipment?.carrierReference || shipment?.internalReference
            // }
            url={item?.url || ""}
            ddtEnabled={ddtEnabled}
            shipmentId={shipment?.id || ""}
            setDdtEnabled={setDdtEnabled}
            checked={true}
          />
        </>
      ) : (
        <iframe
          src={`${item?.url}#toolbar=0&navpanes=0&scrollbar=0&view=Fit&zoom=100`}
          title={item?.name}
          height="275px"
          width="100%"
        />
      )}

      {!isZPL && (
        <div className="d-flex w-100 gap-2 mt-3">
          <ButtonUtility
            className="bg-black text-white border-black w-100"
            onClick={() => window.open(item?.url, "_blank")}
          >
            {dictionary.words.open} PDF
          </ButtonUtility>
        </div>
      )}
    </>
  );
};
